module.exports = __webpack_public_path__ + "img/logo-3.d7655d83.png";